/* ==========================================================================
   Barra de aviso v2 (section announcement-bar-v2). Mede o grupo de textos,
   cria cópias até cobrir a largura da barra e anima o trilho uma largura de
   grupo por volta, em velocidade constante (px/s), para o loop não ter emenda.
   ========================================================================== */

(() => {
  if (window.__abv2) return;
  window.__abv2 = true;

  function setup(bar) {
    const track = bar.querySelector('[data-abv2-track]');
    const group = bar.querySelector('[data-abv2-group]');
    if (!track || !group) return;

    const speed = Math.max(Number(bar.dataset.speed) || 60, 1);

    const measure = () => {
      const groupWidth = group.getBoundingClientRect().width;
      const barWidth = bar.getBoundingClientRect().width;
      if (!groupWidth) return;

      // Cópias suficientes para nunca aparecer buraco: largura da barra + um grupo
      const needed = Math.ceil(barWidth / groupWidth) + 1;
      let copies = track.children.length;
      while (copies < needed) {
        const copy = group.cloneNode(true);
        copy.removeAttribute('data-abv2-group');
        copy.setAttribute('aria-hidden', 'true');
        track.appendChild(copy);
        copies++;
      }

      bar.style.setProperty('--abv2-distance', `${groupWidth}px`);
      bar.style.setProperty('--abv2-duration', `${groupWidth / speed}s`);
      bar.classList.add('is-running');
    };

    measure();
    // Fontes do Typekit chegam depois e mudam a largura do texto
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);
    else window.addEventListener('resize', measure);
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-abv2]').forEach((bar) => {
      if (bar.dataset.abv2Ready) return;
      bar.dataset.abv2Ready = 'true';
      setup(bar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  // Editor de temas: a section é renderizada de novo a cada mudança
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
